import { useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

import { carregarFluxo, mensagemDeErro } from "../api";
import { intervalo } from "../lib/periodos";

/** Período + agrupamento + dados. Atalho troca datas; "Personalizado" respeita o digitado. */
export default function useFluxoCaixa() {
  const inicial = useMemo(() => intervalo("proximos30"), []);
  const [preset, setPreset] = useState("proximos30");
  const [periodo, setPeriodo] = useState(inicial);
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(true);

  const escolherPreset = (p) => { setPreset(p); if (p !== "custom") setPeriodo(intervalo(p)); };
  const definir = (campo, valor) => { if (campo !== "agrupar") setPreset("custom"); setPeriodo((x) => ({ ...x, [campo]: valor })); };

  const recarregar = useCallback(async () => {
    const { inicio, fim } = periodo;
    if (!inicio || !fim || fim < inicio) return;
    setCarregando(true);
    try { setDados(await carregarFluxo(periodo)); } catch (e) {
      toast.error(mensagemDeErro(e, "Não consegui montar o fluxo de caixa."));
    } finally { setCarregando(false); }
  }, [periodo]);

  useEffect(() => { recarregar(); }, [recarregar]);
  return { preset, escolherPreset, periodo, definir, dados, carregando, recarregar };
}
